// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  container: {
    "borderColor-kVAM5u": "borderColor-x9r1u3d",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "alignSelf-kSGwAc": "alignSelf-xqcrz7y",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "minHeight-kAzted": "minHeight-x1ba4aug",
    "paddingBlock-k8WAf4": "paddingBlock-x1vvogim",
    "paddingInline-kg3NbH": "paddingInline-x1awh872",
    $$css: "wino-gc:src/resources/actions/ButtonPhased.res.js:12"
  },
  containerInteracted: {
    "backgroundColor-kWkggS": "backgroundColor-xhb2u9n",
    $$css: "wino-gc:src/resources/actions/ButtonPhased.res.js:26"
  },
  containerHovered: {
    "backgroundColor-kWkggS": "backgroundColor-x1j3d9h6",
    "borderColor-kVAM5u": "borderColor-x1t4mavk",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "zIndex-kY2c9j": "zIndex-x1n327nk",
    $$css: "wino-gc:src/resources/actions/ButtonPhased.res.js:29"
  },
  containerFocused: {
    "backgroundColor-kWkggS": "backgroundColor-x1j3d9h6",
    "borderColor-kVAM5u": "borderColor-xsdecx7",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    $$css: "wino-gc:src/resources/actions/ButtonPhased.res.js:36"
  },
  containerErrored: {
    "borderColor-kVAM5u": "borderColor-x1fh8xyw",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    $$css: "wino-gc:src/resources/actions/ButtonPhased.res.js:42"
  }
};
function styleProps(disabled, hovered, focused, errored) {
  let tmp;
  let exit = 0;
  if (disabled || !(hovered && focused)) {
    exit = 1;
  } else {
    tmp = styles.containerInteracted;
  }
  if (exit === 1) {
    tmp = {};
  }
  let tmp$1;
  let exit$1 = 0;
  if (disabled) {
    exit$1 = 1;
  } else if (errored) {
    tmp$1 = styles.containerErrored;
  } else if (focused) {
    tmp$1 = styles.containerFocused;
  } else if (hovered) {
    tmp$1 = styles.containerHovered;
  } else {
    exit$1 = 1;
  }
  if (exit$1 === 1) {
    tmp$1 = {};
  }
  return Stylex.props(styles.container, tmp, tmp$1);
}
function textStyleProps(compact) {
  return {
    0: {},
    1: {
      className: "textAlign-xdpxx8g textOverflow-xlyipyv whiteSpace-xuxw1ft direction-xzyj77d overflow-xb3r6kr",
      "data-style-src": "wino-gc:src/resources/actions/ButtonPhased.res.js:47"
    }
  }[!!compact << 0];
}
function ButtonPhased$OptionalTouchable(props) {
  let onPress = props.onPress;
  let children = props.children;
  if (onPress !== undefined) {
    return JsxRuntime.jsx(Touchable.make, {
      children: children,
      disabled: props.disabled,
      onPress: param => onPress()
    });
  } else {
    return children;
  }
}
let make = React.forwardRef((props, ref) => {
  let __disabled = props.disabled;
  let __errored = props.errored;
  let __focused = props.focused;
  let __compact = props.compact;
  let __variation = props.variation;
  let variation = __variation !== undefined ? __variation : "normal";
  let compact = __compact !== undefined ? __compact : false;
  let focused = __focused !== undefined ? __focused : false;
  let errored = __errored !== undefined ? __errored : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let ref$1 = Stdlib_Option.map(ref == null ? undefined : Primitive_option.some(ref), prim => prim);
  let match = styleProps(disabled, props.hovered, focused, errored);
  let match$1 = textStyleProps(compact);
  return JsxRuntime.jsx(ButtonPhased$OptionalTouchable, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(TextStyle.make, {
          children: props.children,
          variation: variation === "neutral" ? "normal" : variation === "subdued" ? "subdued" : "neutral",
          weight: variation === "normal" || variation === "subdued" || variation === "neutral" ? "regular" : "medium",
          size: compact ? "xsmall" : "normal",
          wrap: !compact
        }),
        className: match$1.className,
        style: match$1.style
      }),
      ref: ref$1,
      className: match.className,
      style: match.style
    }),
    disabled: disabled,
    onPress: props.onPress
  });
});
let make$1 = React.memo(make);
export { make$1 as make };
/* styles Not a pure module */